import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const PUBLIC_PREFIXES = ["/careers", "/our-studio"];
const isPublicPath = (p) => PUBLIC_PREFIXES.some((pre) => p === pre || p.startsWith(`${pre}/`));

// Runs the /auth/me session check once, the first time the visitor lands on a
// route that needs a session. Public pages skip it so they stay 401-free.
export default function AuthBootstrap() {
  const { pathname } = useLocation();
  const { refresh, bootstrappedRef } = useAuth();

  useEffect(() => {
    if (bootstrappedRef.current || isPublicPath(pathname)) return;
    refresh();
  }, [pathname, refresh, bootstrappedRef]);

  return null;
}
